<template>
  <div>
    <v-row no-gutters class="table-content">
      <v-col cols="12" class="mr-2">
        <v-img :src="tableImg.val">
          <v-row>
            <v-col cols="3">
              <v-img :src="tableTitleImage.val" contain max-height="14vh" max-width="27vh">
                <v-row>
                  <v-col cols="1"></v-col>
                  <v-col class="header-title" cols="10">
                    <span class="header-title-content">جزئیات دارو</span>
                  </v-col>
                  <v-spacer></v-spacer>
                </v-row>
              </v-img>
            </v-col>
            <v-col cols="1" class="mr-n13">
              <v-btn
                class="mx-2 mt-3 mr-n16"
                fab
                dark
                small
                color="darkColor"
                @click="backToDrugs()"
                elevation="0"
              >
                <v-icon dark>mdi-arrow-right mdi-18px</v-icon>
              </v-btn>
            </v-col>
            <v-spacer></v-spacer>
          </v-row>
          <v-row no-gutters class="background-main mx-2 mt-3">
            <v-col cols="12">
              <v-card height="68vh" elevation="0" class="body-card card-width">
                <v-card-text>
                  <v-row class="mt-2">
                    <span class="part-title-content">اطلاعات دارو</span>
                    <v-divider class="mt-3 mr-3"></v-divider>
                  </v-row>
                  <v-row class="mt-n6">
                    <v-col v-for="item in mainInformation" :key="item.id" :cols="item.size">
                      <user-detail-component
                        :title="item.title"
                        :size="item.size"
                        :text="item.text"
                        :icon="item.icon"
                      ></user-detail-component>
                    </v-col>
                  </v-row>
                  <v-row class="mt-7">
                    <span class="part-title-content">دوزاژ</span>
                    <v-divider class="mt-3 mr-3"></v-divider>
                  </v-row>
                  <v-row class="mt-n6">
                    <v-col v-for="item in information2" :key="item.id" :cols="item.size">
                      <user-detail-component
                        :title="item.title"
                        :size="item.size"
                        :text="item.text"
                        :icon="item.teiconxt"
                      ></user-detail-component>
                    </v-col>
                  </v-row>
                  <v-row class="mt-7">
                    <span class="part-title-content">کانتراندیکاسیون ها</span>
                    <v-divider class="mt-3 mr-3"></v-divider>
                  </v-row>
                  <v-row class="mt-n6">
                    <v-col v-for="item in information3" :key="item.id" :cols="item.size">
                      <user-detail-component
                        :title="item.title"
                        :size="item.size"
                        :text="item.text"
                        :icon="item.icon"
                      ></user-detail-component>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </v-img>
      </v-col>
    </v-row>
    <alert-component
      ref="snackRef"
      :snakTimeOut="snakTimeOut"
      :snackColor="snackColor"
      :snackText="snackText"
      :snakIcon="snakIcon"
    ></alert-component>
  </div>
</template>
<script>
  import UserDetailComponent from '@/components/UserDetailComponent.vue';
  import AlertComponent from '../../../components/AlertComponent.vue';

  import snackBar from '@/Mixins/snackBar.js';
  import SharedMixin from '@/Mixins/Shared';
  import SharedHelper from '@/Helpers/Shared';
  import drugMixin from '@/Mixins/BaseInformation/DrugMixin.js';
  export default {
    inject: ['tableImg', 'tableTitleImage'],
    components: {
      UserDetailComponent,
      AlertComponent,
    },
    mixins: [snackBar, SharedMixin, drugMixin, SharedHelper],
    created() {
      this.$root.$refs.UserDetail = this;
    },
    mounted() {
      this.mounteLoding();
    },
    data() {
      return {
        mainInformation: [],
        information2: [],
        information3: [],
      };
    },
    methods: {
      mounte: function () {
        let drugId = this.$route.params.id;
        this.getDrugDetailFunction(drugId);
      },
      backToDrugs: function () {
        this.$router.push({ name: 'drug' });
      },
      makeDataReady: function (data) {
        let orderTypes = '';
        for (let i = 0; i < data.orderTypes.length; i++) {
          orderTypes += data.orderTypes.title + ',';
        }
        orderTypes = this.removeLastCharechter(orderTypes);
        this.mainInformation.push(
          {
            title: 'عنوان:',
            icon: 'mdi-pill',
            text: data.title ? data.title : '-',
            id: 1,
            size: 4,
          },
          {
            title: 'کد:',
            icon: 'mdi-barcode',
            text: data.code ? data.code : '-',
            id: 2,
            size: 4,
          },
          {
            title: 'گروه دارو:',
            icon: 'mdi-pill-multiple',
            text: data.drugGroup ? data.drugGroup.title : '-',
            id: 3,
            size: 4,
          },
          {
            title: 'واحد دارو:',
            icon: 'mdi-medication',
            text: data.unit ? data.unit.title : '-',
            id: 4,
            size: 4,
          },
          {
            title: 'نحوه تجویز:',
            icon: 'mdi-needle',
            text: orderTypes,
            id: 5,
            size: 4,
          },
        );
        this.information2.push(
          {
            title: 'بیمار 11 سال و کمتر:',
            icon: 'mdi-medical-cotton-swab',
            text: data.dosageNoteForLessThan11 ? data.dosageNoteForLessThan11 : '-',
            id: 1,
            size: 12,
          },
          {
            title: 'بیمار بالای 11 سال:',
            icon: 'mdi-medical-cotton-swab',
            text: data.dosageNoteForMoreThan11 ? data.dosageNoteForMoreThan11 : '-',
            id: 2,
            size: 12,
          },
        );
        this.information3.push({
          title: 'کانتراندیکاسیون ها:',
          icon: 'mdi-clipboard-pulse',
          text: data.contraindication ? data.contraindication : '-',
          id: 1,
          size: 12,
        });
      },
    },
  };
</script>
<style scoped>
  .body-card {
    overflow-y: auto !important;
  }
  .part-title-content {
    font-weight: 600;
    font-size: 14px;
    color: #212121;
  }
  @media only screen and (min-width: 1280px) {
    .table-content {
      margin-top: 0vh !important;
    }
    .card-width {
      width: 99% !important;
      margin-right: 2vh !important;
    }
  }
  @media only screen and (min-width: 1366px) {
    .table-content {
      margin-top: 0vh !important;
    }
    .card-width {
      width: 98.5% !important;
      margin-right: 2vh !important;
    }
  }
  @media only screen and (min-width: 1536px) {
    .table-content {
      margin-top: 1vh !important;
    }
    .card-width {
      width: 99% !important;
      margin-right: 1vh !important;
    }
  }
</style>
